import axiosInstance from "./axiosInstance";

const QuoteService = {
    getQuotes: (page, rowsPerPage) =>
        axiosInstance.get(`/api/quotes?page=${page}&size=${rowsPerPage}`).then(r => r.data),

    searchQuotes: (page, rowsPerPage, searchDTO) =>
        axiosInstance.post(`/api/quotes/search?page=${page}&size=${rowsPerPage}`, searchDTO).then(r => r.data),

    getStats: () =>
        axiosInstance.get('/api/quotes/stats').then(r => r.data),

    getQuote: (id) =>
        axiosInstance.get(`/api/quotes/${id}`).then(r => r.data),

    createQuote: (data) =>
        axiosInstance.post('/api/quotes', data).then(r => r.data),

    updateQuote: (id, data) =>
        axiosInstance.put(`/api/quotes/${id}`, data).then(r => r.data),

    deleteQuote: (id) =>
        axiosInstance.delete(`/api/quotes/${id}`).then(r => r.data),

    addItem: (quoteId, item) =>
        axiosInstance.post(`/api/quotes/${quoteId}/items`, item).then(r => r.data),

    updateItem: (quoteId, itemId, item) =>
        axiosInstance.put(`/api/quotes/${quoteId}/items/${itemId}`, item).then(r => r.data),

    deleteItem: (quoteId, itemId) =>
        axiosInstance.delete(`/api/quotes/${quoteId}/items/${itemId}`).then(r => r.data),

    shareQuote: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/share`).then(r => r.data),

    sendQuoteEmail: (quoteId, emailData) =>
        axiosInstance.post(`/api/quotes/${quoteId}/email`, emailData).then(r => r.data),

    changeStatus: (quoteId, status) =>
        axiosInstance.patch(`/api/quotes/${quoteId}/status`, { status }).then(r => r.data),

    acceptQuote: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/accept`).then(r => r.data),

    downloadQuote: (quoteId) =>
        axiosInstance.get(`/api/quotes/${quoteId}/download`, { responseType: 'blob' }),

    startSigning: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/start-signing`).then(r => r.data),

    requestCustomerSigning: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/request-customer-signing`).then(r => r.data),

    cancelQuote: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/cancel`).then(r => r.data),

    rejectQuote: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/reject`).then(r => r.data),

    duplicateQuote: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/duplicate`).then(r => r.data),

    publishToPortal: (quoteId) =>
        axiosInstance.post(`/api/quotes/${quoteId}/publish-portal`).then(r => r.data),

    getNotes: (quoteId) =>
        axiosInstance.get(`/api/quotes/${quoteId}/notes`).then(r => r.data),

    addNote: (quoteId, body) =>
        axiosInstance.post(`/api/quotes/${quoteId}/notes`, { body }).then(r => r.data),

    updateNote: (quoteId, noteId, body) =>
        axiosInstance.put(`/api/quotes/${quoteId}/notes/${noteId}`, { body }).then(r => r.data),

    deleteNote: (quoteId, noteId) =>
        axiosInstance.delete(`/api/quotes/${quoteId}/notes/${noteId}`).then(r => r.data),
};

export default QuoteService;
